import DashBoard from "./dashboard_page";
import LayoutBarista from "../../../layout/layout_barista";

export function BaristaDashboard() {
  return (
    <LayoutBarista>
      <DashBoard />
    </LayoutBarista>
  );
}
